import { render, staticRenderFns } from "./GroupTabSupport.vue?vue&type=template&id=17808314&scoped=true&"
import script from "./GroupTabSupport.vue?vue&type=script&lang=js&"
export * from "./GroupTabSupport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17808314",
  null
  
)

export default component.exports